import * as aftersales from './aftersales'
import * as article from './article'
import * as cardticket from './cardticket'
import * as common from './common'
import * as community from './community'
import * as company from './company'
import * as datacube from './datacube'
import * as deposit from './deposit'
import * as fans from './fans'
import * as goods from './goods'
import * as im from './im'
import * as login from './login'
import * as logistics from './logistics'
import * as marketing from './marketing'
import * as member from './member'
import * as membercard from './membercard'
import * as menu from './menu'
import * as onecode from './onecode'
import * as pcgoods from './pcgoods'
import * as pctemplate from './pctemplate'
import * as point from './point'
import * as printer from './printer'
import * as promotions from './promotions'
import * as qiniu from './qiniu'
import * as reservation from './reservation'
import * as selfhelpform from './selfhelpform'
import * as shipping from './shipping'
import * as shop from './shop'
import * as template from './template'
import * as third from './third'
import * as trade from './trade'
import * as wechat from './wechat'
import * as wxa from './wxa'
import * as wxastats from './wxastats'
import * as addressBook from './addressBook'
import * as webtemplate from './webtemplate'

import * as ossStorage from './ossStorage'

export default {
  aftersales,
  article,
  cardticket,
  common,
  community,
  company,
  datacube,
  deposit,
  fans,
  goods,
  im,
  login,
  logistics,
  marketing,
  member,
  membercard,
  menu,
  onecode,
  pcgoods,
  pctemplate,
  point,
  printer,
  promotions,
  qiniu,
  reservation,
  selfhelpform,
  shipping,
  shop,
  template,
  third,
  trade,
  wechat,
  wxa,
  wxastats,
  ossStorage,
  addressBook,
  webtemplate
}
